/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {SessionTimeout} from '@ion/dls/src/notifications/SessionTimeout';
import {skipUnloadPrompt} from '@/routes/NavigationGuard';
import {sessionTimeout} from '@/store/actions/login';
import {ApplicationState} from '@/store/reducers';

/**
 * The SessionExpired component provides the top-level session timeout UI within
 * the iOn Application.
 */
export const SessionExpired = () => {
  const dispatch = useDispatch();
  const isSessionTimeout = useSelector(({errors}: ApplicationState) => errors.error?.isUnauthorizedError);
  if (isSessionTimeout) {
    return (
      <SessionTimeout show onLogin={function() {
        skipUnloadPrompt();
        dispatch(sessionTimeout());
      }} />
    );
  }
  return null;
};
export default SessionExpired;
